module.exports = __webpack_public_path__ + "media/img/pages/companies/bkw_green-7740c1492e957ee1d521813de7f48fdc.png";